/**
 * Portuguese plan comparison data for tributario.com.br checkout.
 * Extracted from PlanSelector.tsx -- DO NOT localize, these are Brazil-specific.
 */

export const TRIBUTARIO_COMPARISON_DATA = [
  { title: 'Perfil verificado', description: 'Selo de verificação no seu perfil profissional', basica: true, especialista: true, pro: true },
  { title: 'Listado antes de não verificados', description: 'Apareça acima dos usuários não verificados nos resultados', basica: true, especialista: true, pro: true },
  { title: 'Atualizações diárias', description: 'Receba alertas e novidades fiscais todos os dias', basica: true, especialista: true, pro: true },
  { title: 'Card horizontal em destaque', description: 'Layout de card mais amplo e proeminente nos resultados', basica: false, especialista: true, pro: true },
  { title: 'Perfil em destaque', description: 'Apareça em posições privilegiadas nos resultados', basica: false, especialista: true, pro: true },
  { title: 'Métricas de mercado', description: 'Dados e análises exclusivas do mercado tributário', basica: false, especialista: true, pro: true },
  { title: 'Perfis de empresa', description: 'Adicione páginas da empresa em até 5 localizações', basica: false, especialista: false, pro: true },
  { title: 'Conteúdos exclusivos', description: 'Acesso a materiais e análises premium', basica: false, especialista: false, pro: true },
  { title: 'Publicação com prioridade', description: 'Seus artigos são publicados com prioridade editorial', basica: false, especialista: false, pro: true },
  { title: 'Suporte com prioridade', description: 'Atendimento prioritário da equipe de suporte', basica: false, especialista: false, pro: true },
];

export const TRIBUTARIO_PLAN_COLUMNS = [
  { key: 'basica' as const, label: 'Básica', subtitle: 'Para começar' },
  { key: 'especialista' as const, label: 'Especialista', subtitle: 'Mais visibilidade' },
  { key: 'pro' as const, label: 'PRO', subtitle: 'Máximo alcance' },
];
